<template>
  <modal
    name="propose-challenge-change-overlay"
    classes="overlay-modal"
    @before-open="beforeOpen"
    transition="scale"
    height="auto"
    width="70%"
    :clickToClose="false"
  >
    <div class="text-center">
      <div class="termina-bold">
        <h2
          style="line-height: 1.2 !important; padding-bottom:0px; margin-bottom:30px; text-transform:uppercase"
        >
          {{ message }}
        </h2>

        <h2
          v-if="submessage"
          style="line-height: 1.2 !important; padding-bottom:0px; margin-bottom:20px;"
        >
          {{ submessage }}
        </h2>

        <h3
          style="line-height: 1.2 !important; padding: 20px 0 0 0; margin: 0px"
        >
          Are you sure you want to continue?
        </h3>
        <h3
          style="line-height: 1.2 !important; padding: 20px 0 0 0; margin: 0px"
        >
          Anyone on the team can press YES or NO to continue game play.
        </h3>
      </div>
      <div style="margin-top: 40px; padding-bottom: 30px">
        <span
          v-if="awaitingServerResponse"
          class="button-loading-spinner"
        ></span>
        <template v-else>
          <a
            style="margin-right: 10px;  !important;"
            class="btn-red"
            @click="yesClicked"
            :disabled="awaitingServerResponse"
            >Yes</a
          >
          <a
            class="btn-white"
            @click="noClicked"
            :disabled="awaitingServerResponse"
            >No</a
          >
        </template>
      </div>
    </div>
  </modal>
</template>
<script>
import { challengeNavigationMixin } from '../mixins/challengeNavigationMixin'

export default {
  mixins: [challengeNavigationMixin],
  data() {
    return {
      submessage: '',
      message: 'Are you sure?'
    }
  },
  methods: {
    beforeOpen(event) {
      console.log(
        `setting the values '${event.params.code}', '${event.params.team_id}'`
      )

      this.proposedChallengeIndex = event.params.proposedChallengeIndex
      this.code = event.params.code
      this.team_id = event.params.team_id
      this.submessage = event.params.submessage
      this.message = event.params.message
    },
    closeModal() {
      this.$modal.hide('propose-challenge-change-overlay')
    },
    noClicked() {
      this.setProposedChallengeIndex(this.code, this.team_id, undefined)
    },
    yesClicked() {
      this.setCurrentChallengeIndex(
        this.code,
        this.team_id,
        this.proposedChallengeIndex
      )
    }
  }
}
</script>
